import { PanelType } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataTicket } from '../../data/DataTicket';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxScribaNetEiffage } from '../ComboBox/ComboBoxScribaNetEiffage';
import { EUIDatePicker } from '../EUI/EUIDatePicker';
import { EUIPanel } from '../EUI/EUIPanel';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

export class FicheTicketHistorique extends Component {

    static defaultProps = {
        idTicket: undefined,
        idTicketHistorique: undefined,
        isOpen: false,
        /* --- */
        onDismiss: () => null,
        onSave: () => null,
    };

    static defaultState = {
        ticketHistorique: {
            creerLe: new Date(Date.UTC(new Date().getUTCFullYear(), new Date().getMonth(), new Date().getUTCDate())),
            creerPar: "PC",
            description: "",
        },
        onActiveBoutonEnregistrer: false,
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheTicketHistorique.defaultState };
    };

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement de l'historique"
        });

        const { idTicketHistorique } = this.props;
        DataTicket._chargementFicheTicketHistorique(idTicketHistorique).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const ticketHistorique = responseFetch.reponseAPIobjet;
                const state = { ticketHistorique };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else {
                Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            }
        });

    };

    _enregistrer = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Enregistrement de l'historique en cours",
        });

        const { idTicket, onSave } = this.props;
        const ticketHistorique = {
            idTicket,
            ...this.state.ticketHistorique
        };

        DataTicket._onEnregistrementTicketHistorique(ticketHistorique).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, onSave);
            else
                Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });
    };

    _onOpen = () => {
        const { idTicketHistorique } = this.props;
        this.setState({ ...FicheTicketHistorique.defaultState });
        if (idTicketHistorique)
            this._chargementDonnees();
    };

    _onVerificationFormulaire = () => {
        Immocom.fiche()._validationFormulaire(this, 'TicketHistorique', this.state.ticketHistorique, (this.state.ticketHistorique.idTicketHistorique > 0 ? 'Modification' : 'Création'));
    };

    render = () => {

        const { idTicketHistorique, isOpen, onDismiss } = this.props;
        const { onActiveBoutonEnregistrer, ticketHistorique } = this.state;

        const aujourdhui = new Date(Date.now());

        return <EUIPanel
            headerText={!!idTicketHistorique ? "Edition de l'historique" : "Création d'un historique"}
            isFormValid={!!onActiveBoutonEnregistrer}
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onSave={this._enregistrer}
            type={PanelType.large}
        >
            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <ComboBoxScribaNetEiffage
                label="Créé par"
                onChange={(event, option, index, value, item) => Scriba.state().setObjetPropriete(this, "ticketHistorique", "creerPar", option.key !== "0" ? option.key : null, this._onVerificationFormulaire)}
                placeholder="Créé par"
                selectedKey={ticketHistorique.creerPar}
            />

            <EUIDatePicker
                label="Créé le"
                maxDate={aujourdhui}
                onSelectDate={date => Scriba.state().setObjetPropriete(this, "ticketHistorique", "creerLe", Scriba.date().getChaineISOFromDate(date), this._onValidationSurSortieDeChamp)}
                placeholder="Date"
                value={ticketHistorique.creerLe}
            />

            <EUITextField
                label="Description du ticket"
                maxLength={MaxLengths.ticketHistorique.description}
                multiline
                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "ticketHistorique", "description", newValue, this._onVerificationFormulaire)}
                required
                rows={15}
                value={ticketHistorique.description}
            />

        </EUIPanel>;
    };

};